import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=089e2e18&scoped=true&"
import script from "./ProductCarousel.vue?vue&type=script&lang=ts&"
export * from "./ProductCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=089e2e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e2e18",
  null
  
)

export default component.exports